import { Box, Card, Stack, Typography } from "@mui/material";
import { CLASS_PRICES_13_17, CLASS_PRICES_18_PLUS, PriceRow } from "../../shared";

function PriceGroup({ title, rows }: { title: string; rows: PriceRow[] }) {
  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ color: "primary.main" }}>
        {title}
      </Typography>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        {rows.map((row, i) => (
          <Card key={i} sx={{ flex: 1, p: 2, textAlign: "center" }}>
            <Typography variant="h5">{row.price}</Typography>
            <Typography variant="body2" color="text.secondary">
              {row.voltBjj}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {row.accessHomaBjj ? "Accès Homa BJJ inclus" : "Volt BJJ seulement"}
            </Typography>
          </Card>
        ))}
      </Stack>
    </Box>
  );
}

export function PricingCards() {
  return (
    <Stack spacing={4}>
      <PriceGroup title="13 à 17 ans" rows={CLASS_PRICES_13_17} />
      <PriceGroup title="18 ans et plus" rows={CLASS_PRICES_18_PLUS} />
    </Stack>
  );
}
